import { makeStyles, Theme } from "@material-ui/core"
import { isSmallScreen } from "@/utils/checkDevice"
import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"

type StyleProps = {
	paperWidth?: number | string
}

const useStyles = makeStyles<Theme, StyleProps>(theme => ({
	paper: {
		margin: theme.spacing(2),
		zIndex: 1600,
		width: ({ paperWidth }) => paperWidth || undefined
	},
	drawerPaper: {
		width: `${isSmallScreen && "100vw"}`
	},
	paperFullWidth: {
		width: "calc(100% - 32px)"
	},
	templateDialogWidth: {
		minWidth: "calc(70% - 32px)"
	},
	dialogContainer: {
		position: "relative",
		padding: theme.spacing(3)
	},
	closeIcon: {
		position: "absolute",
		top: 20,
		right: 10
	},
	dialogActions: {
		marginTop: theme.spacing(2)
	},
	dialogContent: {
		overflowY: "inherit"
	},
	secondaryActionButton: {
		...ColorUtil.getBackgroundAndContrastColor(colors.purple[50])
	},
	button: {
		height: "40px",
		padding: "0px 8px",
		fontSize: "14px"
	},
	defaultTitle: {
		color: colors.gray[900]
	},
	titleIcon: {
		display: "flex",
		alignItems: "center"
	}
}))

export default useStyles
